'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useResolvedTheme } from '@/hooks/use-resolved-theme';

// Resolves the local `theme` setting ('system' | 'light' | 'dark', via
// useResolvedTheme) to the shadcn-standard .dark class on <html> — 'system'
// tracks the OS preference live via matchMedia, no polling. Also mirrors a
// .light class (unused by our own CSS, which only keys off .dark) so
// anything doing its own document-class theme detection — e.g. mapcn's Map
// component when no explicit `theme` prop is passed — resolves the app's
// actual theme instead of falling back to raw OS preference.
export const ThemeProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const resolvedTheme = useResolvedTheme();
  let t1;
  let t2;
  if ($[0] !== resolvedTheme) {
    t1 = () => {
      const isDark = resolvedTheme === "dark";
      document.documentElement.classList.toggle("dark", isDark);
      document.documentElement.classList.toggle("light", !isDark);
    };
    t2 = [resolvedTheme];
    $[0] = resolvedTheme;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return children;
};